import React, { Component } from 'react'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import Filter from 'components/Filter'

const initState = {
  area_ids: [],
  department_ids: [],
  grade_ids: [],
  job_title_ids: [],
  location_ids: [],
  mol_registration_ids: [],
  business_units: [],
}

class EligiblePeopleFilters extends Component {
  state = { ...initState }

  submitFilters = (filters) => {
    this.setState(filters, () => this.props.onSubmit(this.state))
  }

  render() {
    const { filters, setDisableSelectAll } = this.props
    return (
      <Filter
        filters={filters}
        onSubmitFilter={(params) => {
          const isEmptyParams = Object.values(params).every((item) => isEmpty(item))
          setDisableSelectAll(!isEmptyParams)
          this.submitFilters(params)
        }}
        onClearFilters={() => {
          setDisableSelectAll(false)
          this.setState(initState, () => this.props.onSubmit(initState))
        }}
      />
    )
  }
}
EligiblePeopleFilters.defaultProps = {
  filters: [
    'areas',
    'departments',
    'parent_departments',
    'grades',
    'job_titles',
    'locations',
    'mol_registrations',
  ],
}

EligiblePeopleFilters.propTypes = {
  onSubmit: PropTypes.func,
  setDisableSelectAll: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.string),
}

export default EligiblePeopleFilters
